import React from 'react';
import PropTypes from 'prop-types';

import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { typeGraphsDefaultData } from './TypeGraphsData';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const getGraphData = ({
	xTitle,
	yTitle,
	title,
	xLabels,
	lineColor = 'rgb(255, 99, 132)',
	data,
	dataLabels,
	yLabels = {}
}) => {
	let options = { ...typeGraphsDefaultData };
	let datasets = [];
	if( Array.isArray(data) ) {
		if( Array.isArray(data[0]) ) {
			for( let index = 0; index < data.length; ++index ) {
				let tmpDataset = {
					data: Array.isArray(data[index]) && data[index],
					borderColor: lineColor[index],
					backgroundColor: lineColor[index]
				};
				if( Array.isArray(dataLabels) && dataLabels.length > 0 ) {
					alert(dataLabels);
					tmpDataset["label"] = dataLabels[index];
				}
				datasets.push(tmpDataset);
			}
		} else {
			datasets.push({
				data: Array.isArray(data) && data,
				borderColor: lineColor,
				backgroundColor: lineColor,
			});
		}
	}
	let graphData = {
		labels: xLabels,
		datasets: datasets
	};
	if (title)
		options['plugins'] = {
			...options['plugins'],
			legend: {
				display: !!(Array.isArray(data) && Array.isArray(data[0]) && Array.isArray(data[0]["dataLabels"])),
			},
			title: {
				display: true,
				text: title
			}
		};
	if (xTitle)
		options['scales'] = {
			xAxes: {
				title: {
					display: true,
					text: xTitle
				}
			}
		};
	if (yTitle) {
		if( !yLabels || Object.keys(yLabels).length === 0 ) {
			options['scales'] = {
				...options['scales'],
				yAxes: {
					title: {
						display: true,
						text: yTitle
					}
				}
			};
		} else {
			options['scales'] = {
				...options['scales'],
				yAxes: {
					title: {
						display: true,
						text: yTitle
					},
					min: yLabels["min"],  // valor mínimo del eje Y
					max: yLabels["max"],  // valor máximo del eje Y
					ticks: {
						stepSize: yLabels["interval"] // opcional: define el intervalo entre marcas
					}
				}
			};
		}

	}
	return { options, data: graphData };
};

const LineGraph = (props) => {
	const { className } = props;
	const { options, data } = getGraphData(props);

	return <div className={className}>{data && options && <Line options={options} data={data} />}</div>;
};

LineGraph.propTypes = {
	className: PropTypes.string,
	xTitle: PropTypes.string,
	yTitle: PropTypes.string,
	title: PropTypes.string.isRequired,
	xLabels: PropTypes.array.isRequired,
	lineColor: PropTypes.string,
	data: PropTypes.array.isRequired,
	yLabels: PropTypes.object,
};

export default LineGraph;
